module.exports = __webpack_public_path__ + "static/img/draw_area.5b41a44.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/draw_area.png
// module id = 560
// module chunks = 1